// extracted by mini-css-extract-plugin
module.exports = {"product__delivery_info":"deliveryDays_product__delivery_info__buN_7","product__delivery_date":"deliveryDays_product__delivery_date__XLsqs"};